import $ from 'jquery';

function cookieNoticeMessage( className ) {
	var text = window.icn_cookie_variables.iframe_template_data.text;
	var more_information_text = window.icn_cookie_variables.notice_template_data.more_information_text;

	$( className ).html( '<div class="cookie-notice-message"><div class="cookie-notice-message__text">' + text + '</div><a href="#" class="button" onclick="icn_cookie_notice.show()">' + more_information_text + '</a></div>' );

}

window.cookieNoticeMessage = {
	replaceHtml: cookieNoticeMessage
};